import Config from '@/lib/config';
import { DataLevel, Region, Year } from '@/lib/model';

export const FILTERS = [
  {
    label: 'Regione',
    value: DataLevel.REGIONE,
  },
  {
    label: 'Provincia',
    value: DataLevel.PROVINCIA,
  },
  {
    label: 'Comune',
    value: DataLevel.COMUNE,
  },
];

export const REGIONS = [
  // {
  //   label: 'Lombardia',
  //   value: Region.LOMBARDIA,
  // },
  // {
  //   label: 'Lazio',
  //   value: Region.LAZIO,
  // },
  // {
  //   label: 'Comuni',
  //   value: Region.ALL,
  // },
  {
    label: 'Abruzzo',
    value: Region.ABRUZZO,
  },
].filter(r => {
  // show active regions depending on client
  if (Config.activeRegions === 'all') {
    return true;
  }

  return r.label.toLowerCase() === Config.activeRegions;
});

export const YEARS = [
  // {
  //   label: '2018 - Regionali',
  //   value: Year.Y2018,
  // },
  {
    label: '2019 - Regionali',
    value: Year.Y2019,
  },
  {
    label: '2022 - Politiche',
    value: Year.Y2022,
  },
  // {
  //   label: '2023 - Regionali',
  //   value: Year.Y2023,
  // },
  {
    label: '2024 - Regionali',
    value: Year.Y2024,
  }
];
